var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minus-circle-svgrepo-com (1) 1",
    clipPath: "url(#clip0_612_3690)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set"
  }, /*#__PURE__*/React.createElement("path", {
    id: "minus-circle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91406 13.7383C4.53131 13.7383 1.78906 10.9952 1.78906 7.61328C1.78906 4.23141 4.53131 1.48828 7.91406 1.48828C11.2968 1.48828 14.0391 4.23141 14.0391 7.61328C14.0391 10.9952 11.2968 13.7383 7.91406 13.7383ZM7.91406 0.613281C4.04787 0.613281 0.914062 3.74578 0.914062 7.61328C0.914062 11.4808 4.04787 14.6133 7.91406 14.6133C11.7802 14.6133 14.9141 11.4808 14.9141 7.61328C14.9141 3.74578 11.7802 0.613281 7.91406 0.613281ZM10.5391 7.17578H5.28906C5.04712 7.17578 4.85156 7.37266 4.85156 7.61328C4.85156 7.85391 5.04712 8.05078 5.28906 8.05078H10.5391C10.781 8.05078 10.9766 7.85391 10.9766 7.61328C10.9766 7.37266 10.781 7.17578 10.5391 7.17578Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_3690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.914062 0.613281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusDelete);
export default __webpack_public_path__ + "static/media/minusDelete.94a364bce4e7990c3a38baa54f6f6f04.svg";
export { ForwardRef as ReactComponent };